import { StandaloneNodeLogger } from '@wix/standalone-node-bi-logger';
import type { BiEvent, BiLogger } from '@wix/wix-bi-logger-client';
import { readUserConfig } from '@wix/cli-user-config';
import { getTestOverrides } from '@wix/cli-test-overrides';
import { resolveUserFields } from './add-user-fields.js';

export async function createBiLogger(
  defaultFields?: BiEvent,
  userId?: string
): Promise<BiLogger> {
  const testBaseUrl = getTestOverrides().biLoggerBaseUrl;
  const options = testBaseUrl ? { baseUrl: testBaseUrl } : {};
  const userFields = resolveUserFields(userId);
  const { telemetry: isTelemetryOn } = await readUserConfig();

  return new StandaloneNodeLogger()
    .factory(options)
    .updateDefaults({
      localTime: () => Date.now(),
      ...defaultFields,
      ...userFields,
    })
    .setMuted(!isTelemetryOn)
    .logger();
}
